import React from "react";
import Main from "./components/containers/Main";

function App(props) {
  return <Main />;
}

export default App;
